//import "./mega_menu";
//import "./accordion"; // footer accordion?
//import "./tooltip";
//import "./stacked-table";
//import "./carousel-buttons";
//import MuSearchDesktop from "./MuSearchDesktop";
//import suggestions from "./search-suggestion";

// muCarousel();
// MuSearchDesktop();

console.log("index.js loaded");

import Chatlink from "./chatlink"; // live chat
import initMuCardPods from "./muCardPod"; // card pods
import initMuAccordion from "./muAccordion"; // list accordion
import initMuCarousel from "./muCarousel"; // homepage carousel
import initMuSearchMobile from "./MuSearchMobile"; // mobile search
import initTooltips from "./tooltip"; // tooltip
import initMuStickyMenu from "./sticky-menu";
import initTableScrollAlert from "./tableScrollAlert";
// import initMuGsapAccordion from "./MuAccordionDDS2"; // gsap accordion

import "./muModalBs5";

let chatlink = new Chatlink();

document.addEventListener("DOMContentLoaded", () => {
    initMuCardPods();
    initMuCarousel();
    initMuAccordion();
    initMuSearchMobile();
    initMuStickyMenu();
    initTableScrollAlert();
    initTooltips();
    // initMuGsapAccordion();
});
